import React, {Component} from 'react'
import WpsForm from './WpsForm'
import {WpsFetchQuery} from './mutations'
import {graphql} from 'react-apollo'
import {CardHeader} from 'reactstrap'
import PropTypes from 'prop-types'
import BlockWithLoader from '../Support/BlockWithLoader'

class WpsMain extends Component {

  static propTypes = {
    data: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  render() {
    if (this.props.data.error) {
      if (this.props.data.error.networkError && this.props.data.error.networkError.statusCode === 404) {
        return (<div>Not Found</div>)
      } else {
        return (<div>An unexpected error occurred</div>)
      }
    }

    return (
      <BlockWithLoader loading={this.props.data.loading}>
        <CardHeader>
          <b>WPS</b>
        </CardHeader>
        <WpsForm wpsData={this.props.data.wps} history={this.props.history}/>
      </BlockWithLoader>
    )
  }
}

const WpsMainWithData = graphql(WpsFetchQuery, {
  options: (props) => ({
    fetchPolicy: 'network-only',
    variables: {wps_id: Number(props.match.params.id)}
  }),
})(WpsMain)

export default WpsMainWithData



// WEBPACK FOOTER //
// ./src/components/Wps/WpsMain.js